export const UI_TEXT_LOGIN = {
	title: "Boas vindas ao checklist!",
	subtitle:
		"Antes de iniciar, insira seu CPF e placa do veículo para localizarmos os dados necessários",
	cpfLabel: "CPF",
	cpfPlaceholder: "Informe seu CPF",
	cpfRequired: "CPF é obrigatório",
	plateLabel: "Placa do veículo",
	platePlaceholder: "Informe a placa do veículo",
	plateRequired: "Placa é obrigatória",
	submitButton: "Iniciar checklist",
};
